<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Data Source" active>

                                <b-row v-if="hasFailedDataDataSource">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedDataSource.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="dataSourcesFailed" :fields="fieldsDataSource" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDataSource" :sort-desc.sync="sortDescDataSource" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedDataSource.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="dataSources" :fields="fieldsDataSource" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDataSource" :sort-desc.sync="sortDescDataSource" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import DataSource from '@/models/DataSource/DataSource';
import DataSourceList from '@/models/DataSource/DataSourceList';
import DataSourceFilter from '@/filters/DataSource/DataSourceFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsDataSource: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Name", key: 'name', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			dataSources : [],
			dataSourcesFailed: [],
			dataSourceId : '',
			sortByDataSource: '',
			sortDescDataSource: '',
			hasFailedDataDataSource: false,
			totalFailedDataSource: 0,
			totalSucceedDataSource: 0,

			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('datasource/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('datasource/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getDataSourceForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getDataSourceForUpload : async function() {
			let _this = this;
			this.$http.get('datasource/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.dataSources = [];


					if (response != null) {
						let result = response.data;
						_this.dataSources = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedDataSource = _this.dataSources.length;

						_this.dataSourcesFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataDataSource = true;
						_this.totalFailedDataSource = 0;
						if(_this.dataSourcesFailed == undefined || _this.dataSourcesFailed.length === 0) _this.hasFailedDataDataSource = false;
						if(_this.hasFailedDataDataSource) _this.totalFailedDataSource = _this.dataSourcesFailed.length;

						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'datasource/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'DataSource.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterDataSource = new DataSourceFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
